import React, { useEffect } from "react";
import "../style/PianiDisponibili.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ReactComponent as Assistence } from "../assets/new-icons/assistenza.svg";
import { useNavigate } from "react-router-dom";
import HaveMethod from '../components/PianiDisponibili/HaveMethod';

function PianiDisponibili() {
  const [scroll, setScroll] = React.useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > window.innerHeight / 3
      if (scrollCheck) {
        setScroll(true)
      } else {
        setScroll(false)
      }
    })
  }, [])

  return (
    <div className="pianiDisponibili">
      <div className="pianiDisponibili-top">
        <header>
          <div className="navigation" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </div>
          <div className="assistence">
            <Assistence />
          </div>
        </header>
        {scroll ? (
          <header className='fixed'>
            <div className="navigation" onClick={() => navigate(-1)}>
              <ArrowBackIcon />
            </div>
            <div className="assistence">
              <Assistence />
            </div>
          </header>
        ) : null}
        <div className="text">
          <p className="label">Scopri</p>
          <div className="flex">
            <p className="main epilogue">Scegli il piano più adatto a te!</p>
          </div>
          <p className="secondary">
            Ogni piano è pensato per adattarsi alle tue esigenze di ricarica,
            fatturazione e risparmio. Clicca sul box e scopri i dettagli di ogni
            piano.
          </p>
        </div>
      </div>
      <div className="pianiDisponibili-bottom">
        <HaveMethod />
      </div>
    </div>
  );
}

export default PianiDisponibili;
